import { ParagraphNode } from 'lexical';

export class PlaceholderNode extends ParagraphNode {
  static getType() {
    return 'placeholder';
  }

  static clone(node) {
    return new PlaceholderNode(node.__key);
  }

  createDOM(config) {
    const dom = super.createDOM(config);
    dom.classList.add('report-draft-editor__placeholder');
    return dom;
  }

  updateDOM(prevNode, dom, config) {
    const didUpdate = super.updateDOM(prevNode, dom, config);
    if (!dom.classList.contains('report-draft-editor__placeholder')) {
      dom.classList.add('report-draft-editor__placeholder');
    }
    return didUpdate;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'placeholder',
      version: 1,
    };
  }

  static importJSON(serializedNode) {
    const node = $createPlaceholderNode();
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }
}

export function $createPlaceholderNode() {
  return new PlaceholderNode();
}

export function $isPlaceholderNode(node) {
  return node instanceof PlaceholderNode;
}
